export default function PHP_ftp_quit() {
  return (
    <div>
      <h1>PHP_ftp_quit</h1>
    </div>
  );
}
